import { publicAxios } from './api';

export const getAllCategories = async () => {
  try {
    const response = await publicAxios.get('/resources/allCategory');
    return response.data.data || [];
  } catch (error) {
    console.error("API error in getAllCategories:", error);
    return [];
  }
};

export const getAllResourcesByCategory = async (category) => {
  try {
    const response = await publicAxios.post('/resources/page/category', { category });
    return response.data.data || [];
  } catch (error) {
    console.error(`API error in getAllResourcesByCategory for ${category}:`, error);
    return [];
  }
};

export const increaseResourceDownloadCount = async (category, folderName, fileName) => {
  try {
    const response = await publicAxios.post('/count/resourceDownload', { category, folderName, fileName });
    return response.data.data || null;
  } catch (error) {
    console.error("API error in increaseResourceDownloadCount:", error);
    return null;
  }
};
